import { gql } from '@apollo/client'
import CAREPLAN_DRAFT_FRAGMENT from 'apollo/fragments/CAREPLAN_DRAFT_FRAGMENT'

// CAREPLAN

export default gql`
  query roadmap_v2($id: ID!) {
    roadmap_v2(id: $id) {
      ...CAREPLAN_DRAFT_FRAGMENT
    }
  }
  ${CAREPLAN_DRAFT_FRAGMENT}
`
